module.exports = __webpack_public_path__ + "static/media/twitter-icon.fff1576a.svg";